import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { Deal } from '@/types'
import { Pagination } from '@/types/commons'

export async function listDeals() {
  const response =
    await httpClient('accounting-dealer').get<Pagination<Deal>>(`/v3/deal/list`)

  return response.data.data
}

export function useListDeals(options?: Partial<UseQueryOptions<Deal[]>>) {
  return useQuery({
    queryKey: ['deals'],
    queryFn: listDeals,
    select: (data) =>
      data.filter((deal) => ['ongoing', 'incomplete'].includes(deal.status)),
    ...options,
  })
}
